











import { mapState } from "vuex";
import { Component, Prop, Vue } from "vue-property-decorator";
import commons from "@/common/store/modules/commons";

@Component({
  computed: {
    ...mapState({
      storeColorCode: state => commons.colorCode
    })
  }
})
export default class TextLabelNewArrivalCount extends Vue {
  @Prop({
    type: [String, Number, Boolean],
    required: true,
    default: false
  })
  count!: any;
  storeColorCode: string;

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode
  }

  get colorCode() {
    if(this.isGroupBudget) {
      return '#fc9014'
    }
    return this.storeColorCode
  }

}
